export default "__VITE_ASSET__CjYXb_Ul__"